export default {
	COMUM: {
		SET_EXPANDIR_MENU: 'setExpandirMenu',
		SET_LINK_ARQUIVO: 'setLinkArquivo',
		SET_MENU_AVATAR: 'setMenuAvatar',
		SET_PRODUTO: 'setProduto',
		SET_RETRAIR_MENU: 'setRetrairMenu',
		SET_ROTA_ORIGEM: 'setRotaOrigem',
		SET_USUARIO_LOGADO: 'setUsuarioLogado',
		SET_INFO_CABECALHO: 'setInfoCabecalho',
		SET_KEY_CABECALHO: 'setKeyCabecalho',
		ATUALIZAR_CABECALHO: 'atualizarCabecalho',
		SET_PARAMETROS_SISTEMA: 'setParametrosSistema',
		SET_LOADING_MANUAL: 'setLoadingManual',
		INCREMENT_REQUESTS_IN_PROGRESS: 'incrementRequestsInProgress',
		DECREMENT_REQUESTS_IN_PROGRESS: 'decrementRequestsInProgress',
		SET_EXECUTAR_SEM_LOADING: 'setExecutarSemLoading',
		SET_SALVAMENTO_AUTOMATICO_ERRO: 'setSalvamentoAutomaticoErro',
		MOSTRAR_FALHA_SALVAMENTO_AUTOMATICO: 'mostrarFalhaSalvamentoAutomatico',
		SET_HABILITAR_SALVAMENTO_AUTOMATICO: 'setHabilitarSalvamentoAutomatico',
		SET_DESABILITAR_SALVAMENTO_AUTOMATICO: 'setDesabilitarSalvamentoAutomatico',

		CAMPO_ARQUIVO_NOVO: {
			SET_DOCUMENTO_SELECIONADO: 'comumDocumentosAnexosSetDocumentoSelecionado',
			LIMPAR_DOCUMENTO_SELECIONADO: 'comumDocumentosAnexosLimparDocumentoSelecionado',
			SET_DOCUMENTO_COM_ANEXOS: 'comumDocumentosAnexosSetDocumentoComAnexos',
			LIMPAR_DOCUMENTO_COM_ANEXOS: 'comumDocumentosAtaAnexosLimparDocumentoComAnexos',
			SET_ARQUIVO_TEMPORARIO: 'comumAnexoSetArquivoTemporario',
			SET_ERRO_OBRIGATORIEDADE_ARQUIVO: 'comumAnexoSetArquivoTemporarioSetErroObrigatoriedadeArquivo',
			LIMPAR_ARQUIVO_TEMPORARIO: 'comumAnexoLimparArquivoTemporario',
			SET_ARQUIVO_ENVIADO: 'arquivoEnviado',
		},

		CAMPO_EDITAR_NUMERO: {
			SET_NUMERO: 'comumCampoEditarNumeroSetNumero',
		},

		MODAL_ASSINATURA_FLOWBEE: {
			SET_EXIBICAO: 'setExibicaoModalAssinatura',
			SET_DOCUMENTOS: 'modalAssinaturaSetDocumentos',
			LIMPAR: 'modalAssinaturaLimpar',
		},
	},
	FLOWBEE: {
		SET_HTTP_HEADER: 'flowbeeSetHttpHeader',
	},
	ORGAO: {
		EXIBIR_MODAL_ESCOLHA_ORGAO: 'exibirModalEscolhaOrgao',
		FECHAR_MODAL_ESCOLHA_ORGAO: 'fecharModalEscolhaOrgao',
	},
	CONFIGURACAO: {
		MODELO_DOCUMENTO: {
			SET_PAGINACAO_LISTAGEM: 'configuracaoModeloDocumentoSetPaginacaoListagem',
			RESET_PAGINACAO_LISTAGEM: 'configuracaoModeloDocumentoResetPaginacaoListagem',
			SET_FILTRO_LISTAGEM: 'configuracaoModeloDocumentoSetFiltroListagem',
			RESET_FILTRO_LISTAGEM: 'configuracaoModeloDocumentoResetFiltroListagem',
			SET_IS_EDITAR_NOVO_MODELO_DOCUMENTO: 'configuracaoModeloDocumentoSetIsEditarNovoModeloDocumento',
			SET_DOCUMENTO_MODELO: 'configuracaoSetDocumentoModelo',
			LIMPAR_DOCUMENTO_MODELO: 'configuracaoLimparDocumentoModelo',
			SET_FILTRO_BUSCA_NAO_PAGINADA: 'configuracaoModeloDocumentoSetFiltroBuscaNaoPaginada',
			RESET_FILTRO_BUSCA_NAO_PAGINADA: 'configuracaoModeloDocumentoResetFiltroBuscaNaoPaginada',
			SET_INFORMACOES_MODELO: 'setModeloDocumentoEdicao',
			RESET_INFORMACOES_MODELO: 'resetModeloDocumentoEdicao',
		},
		TIPO_MODELO_DOCUMENTO: {
			RESET_FILTRO: 'configuracaoTipoModeloDocumentoResetFiltro',
			SET_FILTRO_LISTAGEM: 'configuracaoTipoModeloDocumentoSetFiltroListagem',
			RESET_FILTRO_LISTAGEM: 'configuracaoTipoModeloDocumentoResetFiltroListagem',
			SET_PAGINACAO_LISTAGEM: 'configuracaoTipoModeloDocumentoSetPaginacaoListagem',
			RESET_PAGINACAO_LISTAGEM: 'configuracaoTipoModeloDocumentoResetPaginacaoListagem',
		},
		SET_CASAS_DECIMAIS: 'setCasasDecimais',
		FISCAIS: {
			SET_PAGINACAO_LISTAGEM: 'configuracaoFiscaisSetPaginacaoListagem',
			RESET_PAGINACAO_LISTAGEM: 'configuracaoFiscaisResetPaginacaoListagem',
			SET_FILTRO_LISTAGEM: 'configuracaoFiscaisSetFiltroListagem',
			RESET_FILTRO_LISTAGEM: 'configuracaoFiscaisResetFiltroListagem',
		},
		REVISOES: {
			SET_PAGINACAO_LISTAGEM: 'configuracaoRevisoesSetPaginacaoListagem',
			RESET_PAGINACAO_LISTAGEM: 'configuracaoRevisoesResetPaginacaoListagem',
			SET_FILTRO_LISTAGEM: 'configuracaoRevisoesSetFiltroListagem',
			RESET_FILTRO_LISTAGEM: 'configuracaoRevisoesResetFiltroListagem',
		},
	},
	LOKI: {
		SET_FILES_CONFIG: 'SET_FILES_CONFIG',
		ENABLE_AUTO_SAVING: 'ENABLE_AUTO_SAVING',
		DISABLE_AUTO_SAVING: 'DISABLE_AUTO_SAVING',
		RESET_AUTO_SAVE: 'RESET_AUTO_SAVE',
		SET_AUTO_SAVED_MESSAGE: 'SET_AUTO_SAVED_MESSAGE',
		SET_SAVING_MESSAGE: 'SET_SAVING_MESSAGE',
		DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
		ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
		SET_GLOBAL_LOADING: 'setGlobalLoading',
		SET_LOADING_MESSAGE: 'setLoadingMessage',
		SET_MENU_ACTIONS: 'SET_MENU_ACTIONS',
		SET_TIMEZONE: 'setTimezone',
		SHOW_ALERT: 'showAlert',
		SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
		SET_LACUNA_LICENSE: 'SET_LACUNA_LICENSE',
	},
	PROCESSO: {
		SET_FILTRO_PROCESSOS_LISTAGEM: 'setFiltroProcessoListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoFornecedorListagem',
	},
	PROCESSO_UTILIZACAO: {
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoProcessoUtilizacaoListagem',
		SET_FILTRO_LISTAGEM: 'setFiltroProcessoUtilizacaoListagem',
		RESET_INFORMACOES: 'resetInformacoesProcessoUtilizacao',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroListagemProcessoUtilizacao',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaProcessoUtilizacaoListagem',
	},
	FORNECEDOR: {
		SET_FILTRO: 'setFiltroFornecedor',
		SET_PAGINACAO: 'setPaginacaoFornecedor',
	},
	ITEM_PROCESSO: {
		SET_FILTRO_LISTAGEM: 'setFiltroItemProcessoListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoItemProcessoListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaItemProcessoListagem',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroListagem',
		EDITAL: {
			SET_FILTRO: 'setFiltroItemProcessoEdital',
			SET_PAGINACAO: 'setPaginacaoItemProcessoEdital',
		},
	},
	TIPO: {
		SET_FILTRO: 'setFiltroTipoListagem',
		SET_PAGINACAO: 'setPaginacaoTipoListagem',

		POR_NUMERO_E_ITEM_PROCESSO: {
			SET_FILTRO: 'setFiltroTipoPorNumeroEItemProcesso',
			SET_PAGINACAO: 'setPaginacaoTipoPorNumeroEItemProcesso',
		},
	},
	ITEM_ATA: {
		SET_FILTRO_LISTAGEM: 'setFiltroItemAtaListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoItemAtaListagem',
		SET_ITENS_PARA_ADICIONAR: 'setItensParaAdicionar',
		SET_ITENS_ARRAY_PARA_ADICIONAR: 'setItensArrayParaAdicionar',
		SET_IS_SELECIONOU_TODOS_ITENS: 'setIsSelecionouTodosItens',
		UNSET_IS_SELECIONOU_TODOS_ITENS: 'unsetIsSelecionouTodosItens',
		LIMPAR_ITENS_PARA_ADICIONAR: 'limparItensParaAdicionar',
		RESET_ITENS_ATA_SELECIONADOS: 'resetItensAtaSelecionados',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaItemAtaListagem',
		RESET_PAGINACAO_LISTAGEM: 'resetPaginacaoItemAtaListagem',
		ITEM_ATA_SELECIONADO: 'itensAtaSelecionados',
		SET_FILTRO_ITENS_IGNORADOS: 'setFiltroItensIgnorados',
		ITEM_PARA_EXCLUIR: 'itemParaExcluir',
		GERAR_ATA_COM_PROCESSO: {
			SET_ITENS_SELECIONADOS: 'gerarAtaComProcessoSetItensSelecionados',
		},
		SET_ITEM_SELECIONADO: 'setItemSelecionado',
		REALINHAMENTO: {
			HISTORICO: {
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaListagemHistorico',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoListagemHistorico',
			},
			REALINHAMENTO: {
				RESET_REALINHAR: 'resetRealinhar',
			},
		},
		ADITAMENTO: {
			HISTORICO: {
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaListagemHistorico',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoListagemHistorico',
			},
			ADITAR: {
				RESET_PERCENTUAL: 'resetPercentual',
			},
		},
		ALTERAR_FORNECEDOR: {
			ALTERAR: {
				RESET_ALTERAR_FORNCEDORES: 'resetAlterarFornecedores',
			},
			HISTORICO: {
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaListagemHistorico',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoListagemHistorico',
			},
		},
		TRANSFERENCIA: {
			TRANSFERIR: {
				LIMPAR_FILTRO_LISTAGEM: 'resetFiltroTransferenciaListagem',
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaTransferenciaListagem',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoTransferenciaListagem',
				RESET_JUSTIFICATIVA: 'resetTransferenciaJustificativa',
				SET_JUSTIFICATIVA: 'setTransferenciaJustificativa',
				SET_TOTAL_ELEMENTS: 'setTransferenciaTotalElements',
				SET_TOTAL_PAGES: 'setTransferenciaTotalPages',
				RESET_DATASOURCE: 'resetTransferenciaDatasource',
				RESET_ALTERACOES_TRANSFERENCIA: 'resetTransferenciaAlteracoes',
				SET_ORGAO_CEDENTE: 'setTranferirOrgaoCedente',
			},
			HISTORICO: {
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaHistoricoTransferenciaListagem',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoHistoricoTransferenciaListagem',
			},
		},
		ALTERAR_CLASSIFICACAO: {
			ALTERAR: {
				SET_ALTERACOES_CLASSIFICACAO: 'alterarClassificacaoSetAlteracoes',
				RESET_ALTERACOES_CLASSIFICACAO: 'alterarClassificacaoResetAlteracoes',
				SET_DATASOURCE: 'alterarClassificacaoSetDatasource',
				SET_TOTAL_ELEMENTS: 'alterarClassificacaoSetTotalElements',
				SET_TOTAL_PAGES: 'alterarClassificacaoSetTotalPages',
				RESET_DATASOURCE: 'alterarClassificacaoResetDatasource',
				SET_FAIXA_MIN_CLASSIFICACAO: 'alterarClassificacaoSetFaixaMinClassificacao',
				SET_FAIXA_MAX_CLASSIFICACAO: 'alterarClassificacaoSetFaixaMaxClassificacao',
				SET_JUSTIFICATIVA: 'alterarClassificacaoSetJustificativa',
				RESET_JUSTIFICATIVA: 'alterarClassificacaoResetJustificativa',
				SET_PAGINACAO_LISTAGEM: 'alterarClassificacaoSetPaginacaoListagem',
				RESETAR_PAGINA_LISTAGEM: 'alterarClassificacaoResetarPaginaListagem',
			},
			HISTORICO: {
				SET_DATASOURCE: 'alterarClassificacaoHistoricoSetDatasource',
				SET_TOTAL_ELEMENTS: 'alterarClassificacaoHistoricoSetTotalElements',
				SET_TOTAL_PAGES: 'alterarClassificacaoHistoricoSetTotalPages',
				SET_PAGINACAO_LISTAGEM: 'alterarClassificacaoSetPaginacaoListagemHistorico',
				RESETAR_PAGINA_LISTAGEM: 'alterarClassificacaoResetPaginacaoListagemHistorico',
			},
		},
		BLOQUEIO: {
			BLOQUEAR: {
				RESET_BLOQUEAR: 'resetBloquear',
			},
			HISTORICO: {
				RESETAR_PAGINA_LISTAGEM: 'resetarPaginaListagemHistorico',
				SET_PAGINACAO_LISTAGEM: 'setPaginacaoListagemHistorico',
			},
		},
		SET_HISTORICOS: 'setHistoricosItemAta',
		SET_HISTORICO_ALTERAR_CLASSIFICACAO: 'setHistoricoAlterarClassificacaoItemAta',
		SET_HISTORICO_ALTERAR_FORNECEDOR: 'setHistoricoAlterarFornecedorItemAta',
		SET_HISTORICO_GERENCIAR_SALDO: 'setHistoricoGerenciarSaldo',
		LIMPAR_HISTORICOS: 'limparHistoricoItemAta',
	},
	ATA: {
		SET_FILTRO_LISTAGEM: 'setFiltroAtaListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoAtaListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaAtaListagem',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroAtaListagem',
		SET_INFORMACOES_ATA: 'setInformacoesAta',
		SET_NUMERO_ATA: 'setNumeroAta',
		SET_ID_ORGAO_ABA: 'setIdOrgaoAbaAta',
		RESET_ID_ORGAO_ABA: 'resetIdOrgaoAbaAta',
		RESET_INFORMACOES_ATA: 'resetInformacoesAta',
		SET_BLOQUEIO_ATA: 'setBloqueioAta',
		SET_ENVIADA_PNCP: 'setEnviadaPncp',
		SET_URL_PNCP: 'setUrlPncp',
		SET_LISTA_CONTRATADOS: 'setListaContratados',
		SET_PAINEIS_INFORMACOES_ABERTOS: 'setPaineisAbaInformacoesAbertos',
		ADICIONAR_ABA: 'adicionarAbaNaAta',
		RESETAR_ABA: 'resetarAbasAta',
		ATUALIZAR_LISTAGEM_COM_TIMEOUT: 'atualizarListagemComTimeout',
		DOCUMENTOS_ATA: {
			CHECKBOX: {
				SET_IS_SELECIONOU_TODOS_ITENS: 'setIsSelecionouTodosItens',
				DOCUMENTOS_SELECIONADOS: 'documentosAtaSelecionados',
				DESFAZER_SELECAO_ITENS_LISTAGEM: 'documentosAtaDesfazerSelecaoItensListagem',
			},
			SET_EXIBIR_SINCRONIZAR_AREA_PUBLICA: 'setExibirSincronizarAreaPublica',
			ATUALIZAR_LISTAGEM: 'atualizarListagem',
			ATUALIZAR_LISTAGEM_COM_TIMEOUT: 'atualizarListagemComTimeout',
			RESETAR_PAGINA_LISTAGEM: 'resetarPaginaDocumentoAtaListagem',
			SET_FILTRO_LISTAGEM: 'setFiltroDocumentoAtaListagem',
			SET_PAGINACAO_LISTAGEM: 'setPaginacaoDocumentoAtaListagem',
			LIMPAR_FILTRO_LISTAGEM: 'limparFiltroDocumentoAtaListagem',
		},
		PESQUISA: {
			ADESAO: {
				SET_PAGINACAO_PESQUISA_LISTAGEM: 'setPaginacaoAdesaoPesquisaListagem',
				RESET_PAGINACAO_PESQUISA_LISTAGEM: 'resetPaginacaoAdesaoPesquisaListagem',
				RESETAR_PAGINA_PESQUISA_LISTAGEM: 'resetarPaginaAdesaoPesquisaListagem',
			},
		},
		PARTES_ENVOLVIDAS: {
			SET_LISTAGEM: 'setListagemPartesEnvolvidas',
			LIMPAR_LISTAGEM: 'limparListagemPartesEnvolvidas',
		},
	},
	PEDIDO: {
		RESET_INFORMACOES: 'resetInformacoesPedido',
		SET_INFORMACOES: 'setInformacoesPedido',
		SET_NUMERO: 'setNumeroPedido',
		SET_HAS_AUTORITY: 'setHasAutority',
		SET_ETAPA_FLUXO: 'setEtapaFluxo',
		DOCUMENTOS: {
			ANEXOS: {
				SET_SELECIONADO: 'pedidoDocumentosSetAnexoSelecionado',
				LIMPAR_SELECIONADO: 'pedidoDocumentosLimparAnexoSelecionado',
				SET_DOCUMENTO_COM_ANEXOS: 'pedidoDocumentosSetDocumentoComAnexo',
				LIMPAR_DOCUMENTO_COM_ANEXOS: 'pedidoDocumentosLimparDocumentoComAnexos',
			},
			CHECKBOX: {
				SET_IS_SELECIONOU_TODOS_ITENS: 'pedidoDocumentosCheckboxSetIsSelecionouTodosItens',
				DOCUMENTOS_SELECIONADOS: 'pedidoDocumentosCheckboxDocumentosSelecionados',
				DESFAZER_SELECAO_ITENS_LISTAGEM: 'pedidoDocumentosCheckboxDesfazerSelecaoItens',
			},
			LISTAGEM: {
				SET_FILTRO: 'pedidoDocumentosSetFiltroListagem',
				RESETAR_PAGINA: 'pedidoDocumentosResetarPaginaListagem',
				SET_PAGINACAO: 'pedidoDocumentosSetPaginacaoListagem',
				LIMPAR_FILTRO: 'pedidoDocumentosLimparFiltroListagem',
			},
		},
		SET_ID_ORGAO_FILTRO_COLLAPSE: 'setIdOrgaoFiltroCollapse',
		SET_SITUACAO: 'setSituacaoFiltro',
		RESET_FILTRO_LISTAGEM: 'resetFiltroListagemPedido',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoPedidoListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaPedidoListagem',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroListagemPedidos',
		SET_ID_ORGAO_ABA: 'setIdOrgaoAbaPedido',
		RESET_ID_ORGAO_ABA: 'resetIdOrgaoAbaPedido',
		SET_REVISAO: 'setRevisaoPedido',
	},
	PENALIDADES: {
		RESET_INFORMACOES: 'penalidadeResetInformacoes',
		SET_VISIBILIDADE_ABA: 'penalidadeSetVisibilidadeAba',
		SET_ORGAO_SANCIONADOR_SALVO: 'penalidadeSetOrgaoSancionadorSalvo',
		SET_FORNECEDOR_SALVO: 'penalidadeSetFornecedorSalvo',
		SET_ID_PENALIDADE_SALVA: 'penalidadeSetIdPenalidadeSalva',
		SET_ABA_SELECIONADA: 'penalidadeSetAbaSelecionada',
		SET_SALVAR_EFETIVAR_SANCAO: 'penalidadeSetSalvarEfetivarSancao',
		SET_IS_PENALIDADE_EFETIVADA: 'penalidadeSetIsPenalidadeEfetivada',
		SET_SALVAR_ITENS: 'penalidadeSetSalvarItens',
		SET_INSERIR_NOTIFICACAO: 'penalidadeSetInserirNotificacao',
		SET_NOTIFICACAO_OBRIGATORIA: 'penalidadeSetNotificacaoObrigatoria',
	},
	ITEM_PEDIDO: {
		RESET_FILTRO_LISTAGEM: 'resetFiltroListagemPedido',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoPedidoListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaPedidoListagem',
		ESTORNO: {
			ESTORNAR: {
				SET_FORM: 'itemPedidoEstornoEstornarSetForm',
				RESET_FORM: 'itemPedidoEstornoEstornarResetForm',
			},
			HISTORICO: {
				RESETAR_PAGINACAO: 'itemPedidoEstornoHistoricoResetarPaginacao',
				SET_PAGINACAO: 'itemPedidoEstornoHistoricoSetPaginacao',
				SET_LISTAGEM: 'itemPedidoEstornoHistoricoSetListagem',
			},
		},
		SET_ITENS_SELECIONADOS: 'setItemPedidoSelecionados',
		RESET_ITENS_SELECIONADOS: 'resetItensPedidoSelecionados',
		SET_TODOS_ITENS_SELECIONADOS: 'pedidoIsTodosItensSelecionados',
	},
	FORNECEDOR_ITEM_ATA: {
		SET_ID_ITEM_BUSCAR_FORNECEDORES: 'setIdItemBuscarFornecedores',
	},
	ADESAO: {
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoAdesaoListagem',
		RESET_PAGINACAO_LISTAGEM: 'resetPaginacaoAdesaoListagem',
		RESET_FILTRO_LISTAGEM: 'resetFiltroListagemAdesao',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaAdesaoListagem',
		SET_ITENS_SELECIONADOS: 'setItemAdesaoSelecionados',
		SET_JUSTIFICATIVA: 'setJustificativaAdesao',
		RESET_ITENS_SELECIONADOS: 'resetItensAdesaoSelecionados',
		SET_INFORMACOES_ADESAO: 'setInformacoesAdesao',
		RESET_INFORMACOES_ADESAO: 'resetInformacoesAdesao',
		SET_POSSUI_ITENS_ELABORACAO: 'setPossuiItensElaboracao',
		SET_POSSUI_ITENS_RASCUNHO: 'setPossuiItensRascunho',
		SET_ATUALIZA_LISTAGEM: 'setAtualizaListagemAdesao',
		SET_POSSUI_ITENS: 'setPossuiItensAdesao',
		ITENS: {
			SET_PAGINACAO_LISTAGEM: 'setPaginacaoItensAdesaoListagem',
			RESET_FILTRO_LISTAGEM: 'resetFiltroListagemItensAdesao',
			RESET_PAGINACAO_LISTAGEM: 'resetPaginacaoItensAdesaoListagem',
			RESETAR_PAGINA_LISTAGEM: 'resetarPaginaItensAdesaoListagem',
			ESTORNO: {
				ESTORNAR: {
					SET_FORM: 'itemAdesaoEstornoEstornarSetForm',
					RESET_FORM: 'itemAdesaoEstornoEstornarResetForm',
				},
				HISTORICO: {
					RESETAR_PAGINACAO: 'itemAdesaoEstornoHistoricoResetarPaginacao',
					SET_PAGINACAO: 'itemAdesaoEstornoHistoricoSetPaginacao',
					SET_LISTAGEM: 'itemAdesaoEstornoHistoricoSetListagem',
				},
			},
			SET_ITENS_SELECIONADOS: 'setItemAdesaoSelecionados',
			RESET_ITENS_SELECIONADOS: 'resetItensAdesaoSelecionados',
			SET_TODOS_ITENS_SELECIONADOS: 'adesaoIsTodosItensSelecionados',
		},
		SET_REVISAO: 'setRevisaoAdesao',
	},
	OCORRENCIA: {
		SET_INFORMACOES_OCORRENCIA: 'setInformacoesOcorrencia',
		SET_INFORMACOES_ITENS_OCORRENCIA: 'setInformacoesItensOcorrencia',
		SET_KEY_LISTAR_OCORRENCIAS: 'setKeyListarOcorrencias',
	},
	PERMISSIONAMENTO: {
		SET_ID_ORGAO_PERMISSIONAMENTO: 'setIdOrgaoPermissionamento',
		SET_PERMISSOES_PERMISSIONAMENTO: 'setPermissoesPermissionamento',
	},
	ITEM_ADITIVO_APOSTILA: {
		SET_FILTRO_LISTAGEM: 'setFiltroListagemItensAditivoApostila',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoListagemItensAditivoApostila',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaItensAditigoApostilaListagem',
		SET_INFORMACOES_ITEM_ADITIVO_APOSTILA: 'setInformacoesItemAditivoApostila',
		RESET_INFORMACOES_ITEM_ADITIVO_APOSTILA: 'resetInformacoesItemAditivoApostila',
		SET_TIPO_OPERACAO: 'setTipoOperacaoItemAditivoApostila',
		SET_QUANTIDADE_SUPRESSAO_ACRESCIMO: 'setQuantidadeAcrescimoSupressaoItemAditivoApostila',
		ITEM_ADITIVO_APOSTILA_SELECIONADO: 'setItemAditivoApostilaSelecionado',
		SET_IS_SELECIONOU_TODOS_ITENS: 'setIsSelecionouTodosItensAditivoApostila',
		UNSET_IS_SELECIONOU_TODOS_ITENS: 'unsetIsSelecionouTodosItensAditivoApostila',
	},
}
